import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CountUpBase from 'react-countup';
/**
 * react-countup のラッパーコンポーネント
 * @description 数値変更時のアニメーション
 * @param props
 * @returns
 */
export const CountUp = (props) => {
    const { duration = 1, end, separator = ',', start = 0 } = props;
    return (_jsx(CountUpBase, { duration: duration, end: end, separator: separator, start: start }));
};
